import { useCrowdFundingTranslations } from 'core/Hooks';
import { convertToInitials } from 'core/Utils';
import { useParams } from 'react-router-dom';
import { Avatar, Divider, Flex, Stack, Text } from 'ui';

import { IDonationList } from '../../../types/causes/donor.types';
import { centsToDollar } from '../../../utils/centsToDollar';

type RecentDonationCardProps = {
  donorData: IDonationList;
};

const RecentDonationCard = ({ donorData }: RecentDonationCardProps) => {
  const { uuid } = useParams();
  const { t } = useCrowdFundingTranslations(uuid);

  return (
    <Flex gap="sm">
      <Avatar size="36" radius="xl" color="cobalt.5">
        {convertToInitials(donorData.donor.name)}
      </Avatar>
      <Stack gap="0" justify="space-between" w="100%">
        <Text fz="xs">
          <Text span fw="500" fz="inherit">
            {donorData?.donor.name}
          </Text>
          {` ${t('donated')} `}
          <Text span fw="500" fz="inherit">
            {centsToDollar(donorData.amount)}
          </Text>
        </Text>
        <Text fz="xxxs" c="gray">
          {donorData?.donor.ago}
        </Text>

        <Divider mt="md" />
      </Stack>
    </Flex>
  );
};

export { RecentDonationCard };
